module.exports = __webpack_public_path__ + "img/notivthoutred.d3d2f230.svg";